import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=18cf534e&"
import script from "./Empresa.vue?vue&type=script&lang=ts&"
export * from "./Empresa.vue?vue&type=script&lang=ts&"
import style0 from "./Empresa.vue?vue&type=style&index=0&id=18cf534e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports